export default __webpack_public_path__ + "static/media/Google-Header-banner.47176931.png";